angular
	.module 'App.Module'
	.config ($stateProvider) ->
		$stateProvider
			.state 'journal_events',
				url: '/journal_events',
				views:
					main:
						controller: 'JournalEventController'
						controllerAs: 'vm'
						templateUrl: '@app/journal-event/journal-event.view.html'
				data:
					hideSubMenu: true
					restrict: 'Shared.Setting.JournalEvent.Enabled'
